import { getAxios } from '../lib'
import { get_env } from './get_env'
import { isClient } from './isClient'
import moment from 'moment'

const generateSession = async () => {
   const axios = getAxios()

   const url = `${
      new URL(get_env('GRAPHQL_HTTP_URL')).origin
   }/server/api/session/create`

   // const url = `http://localhost:4000/server/api/session/create`
   const oiType = localStorage.getItem('orderInterfaceType')
   const { data } = await axios.post(url, {
      orderInterfaceType: JSON.parse(oiType),
      deviceInfo: { userAgent: navigator.userAgent },
   })
   if (data.success) {
      sessionStorage.setItem('sessionId', data.sessionId)
      sessionStorage.setItem('sessionExpireTime', data.expireTime)
   } else {
      removeSessionId()
   }
}

const removeSessionId = () => {
   sessionStorage.removeItem('sessionId')
   sessionStorage.removeItem('sessionExpireTime')
}

const isSessionIdValid = () => {
   const expireTime = sessionStorage.getItem('sessionExpireTime')
   if (!expireTime) {
      removeSessionId()
   }

   const valid = moment(moment()).diff(expireTime) < 0

   return valid
}

const sessionId = isClient && sessionStorage.getItem('sessionId')

export { generateSession, isSessionIdValid, removeSessionId, sessionId }
